import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const coreComponentsTranslation = TranslationBlueprint.make({
  name: 'core-components',
  params: {
    resource: createTranslationMessages({
      ref: coreComponentsTranslationRef,
      full: false,
      messages: {
        'signIn.title': 'Inloggen',
        'signIn.loginFailed': 'Inloggen is mislukt',
        'signIn.customProvider.title': 'Eigen gebruiker',
        'signIn.customProvider.subtitle':
          'Vul je eigen gebruikers-ID en inloggegevens in.\n Deze keuze wordt niet bewaard.',
        'signIn.customProvider.userId': 'Gebruikers-ID',
        'signIn.customProvider.tokenInvalid':
          'Het token is geen geldig OpenID Connect JWT-token',
        'signIn.customProvider.continue': 'Doorgaan',
        'signIn.customProvider.idToken': 'ID-token (optioneel)',
        'signIn.guestProvider.title': 'Gast',
        'signIn.guestProvider.subtitle':
          'Ga verder als gast.\n Je identiteit is dan niet geverifieerd, waardoor sommige functies mogelijk niet beschikbaar zijn.',
        'signIn.guestProvider.enter': 'Doorgaan',
        skipToContent: 'Ga naar de inhoud',
        'copyTextButton.tooltipText': 'Tekst gekopieerd naar klembord',
        'simpleStepper.reset': 'Begin opnieuw',
        'simpleStepper.finish': 'Rond af',
        'simpleStepper.next': 'Volgende',
        'simpleStepper.skip': 'Sla over',
        'simpleStepper.back': 'Terug',
        'errorPage.subtitle': 'Fout {{status}}: {{statusMessage}}',
        'errorPage.title': 'Er is iets misgegaan',
        'errorPage.goBack': 'Teruggaan',
        'errorPage.showMoreDetails': 'Toon meer details',
        'errorPage.showLessDetails': 'Toon minder details',
        'emptyState.missingAnnotation.title': 'Annotatie ontbreekt',
        'emptyState.missingAnnotation.actionTitle':
          'Voeg de annotatie toe aan de YAML van je component, zoals in het gemarkeerde voorbeeld hieronder:',
        'emptyState.missingAnnotation.readMore': 'Meer informatie',
        'supportConfig.default.title': 'Ondersteuning is niet ingesteld',
        'supportConfig.default.linkTitle':
          'Voeg de configuratiesleutel `app.support` toe',
        'errorBoundary.title':
          'Neem contact op met {{slackChannel}} voor hulp.',
        'oauthRequestDialog.title': 'Inloggen vereist',
        'oauthRequestDialog.authRedirectTitle':
          'Je wordt doorgestuurd naar de OAuth-inlogpagina.',
        'oauthRequestDialog.login': 'Inloggen',
        'oauthRequestDialog.rejectAll': 'Weiger alles',
        'oauthRequestDialog.message':
          "Log in om {{appTitle}} toegang te geven tot API's en identiteiten van {{provider}}.",
        'supportButton.title': 'Ondersteuning',
        'supportButton.close': 'Sluit',
        'table.filter.title': 'Filters',
        'table.filter.clearAll': 'Wis alles',
        'table.filter.placeholder': 'Alle resultaten',
        'table.body.emptyDataSourceMessage': 'Geen gegevens om te tonen',
        'table.pagination.firstTooltip': 'Eerste pagina',
        'table.pagination.labelDisplayedRows': '{from}-{to} van {count}',
        'table.pagination.labelRowsSelect': 'rijen',
        'table.pagination.lastTooltip': 'Laatste pagina',
        'table.pagination.nextTooltip': 'Volgende pagina',
        'table.pagination.previousTooltip': 'Vorige pagina',
        'table.toolbar.search': 'Filter',
        'table.header.actions': 'Acties',
        'alertDisplay.message_one': '({{ count }} nieuwer bericht)',
        'alertDisplay.message_other': '({{ count }} nieuwere berichten)',
        'autoLogout.stillTherePrompt.title':
          'Je wordt uitgelogd wegens inactiviteit',
        'autoLogout.stillTherePrompt.buttonText': 'Blijf ingelogd',
        'dependencyGraph.fullscreenTooltip': 'Schakel volledig scherm om',
        'proxiedSignInPage.title':
          'Je lijkt niet ingelogd te zijn. Laad de pagina opnieuw in je browser.',
        'logViewer.downloadBtn.tooltip': 'Download logs',
        'logViewer.copyBtn.tooltip': 'Kopieer logs naar klembord',
        'logViewer.searchField.placeholder': 'Zoek',
      },
    }),
  },
});
